import React, { useContext } from 'react';
import styled from 'styled-components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { EmptyState } from 'shared/components';

const ButtonWrapper = styled.div`
  margin-top: 20px;
`;

const EmptyStateWrapper = styled.div`
  padding-bottom: 20px;
`;

const TicketsHistoryEmptyState = ({ createTicketButton }) => {
  const { t } = useContext(ConfigContext);

  return (
    <EmptyStateWrapper>
      <EmptyState text={t('help_desk_no_tickets_yet')} subText={t('help_desk_no_tickets_yet_description')}>
        {createTicketButton && <ButtonWrapper>{createTicketButton}</ButtonWrapper>}
      </EmptyState>
    </EmptyStateWrapper>
  );
};

export default TicketsHistoryEmptyState;
